import { FormTypes } from './interfaces/form-types';
import { InputProps } from './interfaces/input-props';

export const forms: Record<FormTypes, InputProps[]> = {
	'add-edit-expense': [
		{
			label: 'Description',
			type: 'text',
			name: 'description',
			placeholder: 'Enter description',
			validations: [
				{
					type: 'required',
					message: 'Description is required',
				},
			],
		},
		{
			label: 'Date',
			type: 'datepicker',
			name: 'dateTime',
			validations: [
				{
					type: 'required',
					message: 'Date is required',
				},
			],
		},
		{
			label: 'Amount',
			type: 'number',
			name: 'amount',
			validations: [
				{
					type: 'required',
					message: 'Amount is required',
				},
			],
		},
	],
	'add-edit-settlement': [
		{
			label: 'Amount',
			type: 'number',
			name: 'amount',
			validations: [
				{
					type: 'required',
					message: 'Amount is required',
				},
			],
		},
		{
			label: 'Date',
			type: 'datepicker',
			name: 'dateTime',
			validations: [
				{
					type: 'required',
					message: 'Date is required',
				},
			],
		},
	],
};
